import { createReducer, on } from "@ngrx/store";
import { InitialSuggestionState } from "./suggestions.state";
import { SuggestionsActions } from "./suggestions.actions";


export const SuggestionReducer = createReducer(InitialSuggestionState,
  on(SuggestionsActions.loadData, (state, { data, meta }) => ({ ...state, data, meta }))
)